import skaterImg from '../assets/figure_skater.png';
import { trackCTAClick } from '../analytics';

export default function Hero() {
  return (
    <section className="hero" id="top">

      {/* ── BACKGROUND TEXT ─────────────────────────── */}
      <div className="hero__bg-text">
        <span className="hero__dev">DEVELOPMENT</span>
        <span className="hero__isart">IS ART.</span>
      </div>

      {/* ── LEFT SIDE TEXT ──────────────────────────── */}
      <div className="hero__side hero__side--left">
        <div className="hero__side-head">
          OBSESSION<br />MAKES IT<br />BEAUTIFUL.
        </div>
        <p className="hero__side-body">
          We pour everything into<br />
          the details others overlook.<br />
          That's where beauty lives.
        </p>
      </div>

      {/* ── RIGHT SIDE TEXT ─────────────────────────── */}
      <div className="hero__side hero__side--right">
        <div className="hero__side-head">
          DISCIPLINE<br />MAKES IT REAL.
        </div>
        <p className="hero__side-body">
          We build with focus,<br />
          precision, and purpose.<br />
          That's how ideas last.
        </p>
      </div>

      {/* ── SKATER ──────────────────────────────────── */}
      <div className="hero__skater">
        <img
          src={skaterImg}
          alt="figure skater"
          className="hero__skater-img"
        />
      </div>

      {/* ── CTA BUTTON ──────────────────────────────── */}
      <div className="hero__cta">
        <a
          href="#contact"
          className="btn-border"
          onClick={() => trackCTAClick('BUILD TOGETHER', 'hero')}
        >
          BUILD TOGETHER →
        </a>
      </div>
    </section>
  );
}
